module.exports = __webpack_public_path__ + "static/media/amulet-normal.ded3ac80.png";